const searchInOrgContextActions = {
  SEARCH_IN_ORG_CONTEXT_INIT_STATE_SET: 'SEARCH_IN_ORG_CONTEXT_INIT_STATE_SET',
  SHEET_IS_SHOWN_UPDATE: 'SHEET_IS_SHOWN_UPDATE',
  SEARCH_IN_ORG_CONTEXT_REQUEST_BODY_PROP_UPDATE: 'SEARCH_IN_ORG_CONTEXT_REQUEST_BODY_PROP_UPDATE'
};
export default searchInOrgContextActions;
